export default __webpack_public_path__ + "static/media/lightning.5b9316bb.svg";